var Flowcor = Flowcor || {};

Flowcor.GoogleMaps = function() {

  var _defaults = {
    id : 'Map',
    lat : 51.15073424410806,
    long : 4.905039279249947,
    zoom : 10
  };

  var _mapStyles = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#0072ba"
            },
            {
                "visibility": "on"
            }
        ]
    }
  ]

  var _settings = {};

  var _init = function(options) {
    _settings = $.extend({}, _defaults, options || {});
    // base map
    var map = new google.maps.Map(document.getElementById(_settings.id), {
      center: {
        lat : _settings.lat,
        lng : _settings.long
      },
      zoom: _settings.zoom,
      mapTypeControlOptions: {
        mapTypeIds: ['styled_map']
      },
      disableDefaultUI: true,
      gestureHandling: 'none',
      zoomControl: false
    });
    // custom styles
    var styledMapType = new google.maps.StyledMapType(_mapStyles, {name: 'Styled Map'});
    map.mapTypes.set('styled_map', styledMapType);
    map.setMapTypeId('styled_map');
    // custom marker
    var marker = new google.maps.Marker({
      position: new google.maps.LatLng(_settings.lat, _settings.long),
      icon: ValueJSConfig.root + 'img/layout/marker.png',
      animation: google.maps.Animation.BOUNCE,
      map: map
    });
  }

  /** PUBLIC API **/
  return {
    init : function(options) {return _init(options);}
  };

}();
